import React, { Component } from 'react';

class MortgageChoiceConsent extends Component {
  render() {
    const { onConsentChange, consented, hideCheckbox } = this.props;

    return (
      <div className="bg-white">
        <div className="text-center mb-8 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Mortgage Choice Pty Ltd / Smartline Operations Pty Ltd</h2>
          <p className="text-sm text-gray-600 italic mb-3">Authorised under CBD Mortgage Advisors Pty Ltd</p>
          <div className="space-y-1 text-sm text-gray-700">
            <p className="flex items-center justify-center">
              <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
              </svg>
              customerservice@mortgagechoice.com.au
            </p>
            <p className="flex items-center justify-center">
              <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
              </svg>
              511 Church Street, Richmond VIC 3121
            </p>
            <p className="flex items-center justify-center">
              <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
              </svg>
              02 8907 0444
            </p>
          </div>
        </div>
        
        <div className="text-gray-800 space-y-8">
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">1</span>
              What We Collect
            </h3>
            <p className="leading-relaxed mb-4">We collect personal and sensitive information such as:</p>
            <ul className="list-disc ml-6 space-y-2 text-gray-700">
              <li>Your name, date of birth, contact and ID details</li>
              <li>Employment and income details</li>
              <li>Financial position including assets, liabilities, expenses</li>
              <li>Credit history and credit report data</li>
              <li>Health information (only with your consent)</li>
            </ul>
            <p className="leading-relaxed mt-4">This may come from you, your broker, authorised representatives, credit reporting bodies (e.g. Equifax, Illion), lenders, financial institutions, or through the Consumer Data Right framework (with your consent).</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">2</span>
              How We Use It
            </h3>
            <p className="leading-relaxed mb-4">Your information is used to:</p>
            <ul className="list-disc ml-6 space-y-2 text-gray-700">
              <li>Provide mortgage broking and credit assistance</li>
              <li>Verify your identity and assess loan suitability</li>
              <li>Submit and manage loan or lease applications</li>
              <li>Comply with legal obligations (e.g. anti-money laundering)</li>
              <li>Offer related products and services (you may opt out)</li>
              <li>Improve our service delivery and client support</li>
              <li>Detect and prevent fraud or unlawful activity</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">3</span>
              Disclosure of Information
            </h3>
            <p className="leading-relaxed mb-4">We may disclose your personal and credit-related information to:</p>
            <ul className="list-disc ml-6 space-y-2 text-gray-700">
              <li>Lenders, mortgage insurers, and credit reporting bodies</li>
              <li>Referrers, financial or legal advisers, and IT system providers</li>
              <li>Our offshore processing support team in the Philippines</li>
              <li>Government bodies, regulators, auditors, and insurers</li>
              <li>Any party you authorise, or as required by law</li>
            </ul>
            <p className="leading-relaxed mt-4">Some disclosures may occur to overseas locations where data is stored or processed securely.</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">4</span>
              Credit Reporting & Notifiable Matters
            </h3>
            <p className="leading-relaxed mb-4">You authorise us to:</p>
            <ul className="list-disc ml-6 space-y-2 text-gray-700">
              <li>Act as your access seeker to request your credit report</li>
              <li>Disclose your credit information to relevant lenders</li>
              <li>Share repayment history, defaults, or serious infringements where required</li>
              <li>Exchange data with credit reporting bodies for identity verification and assessment</li>
              <li>Flag your file for suspected fraud on your request</li>
            </ul>
            <p className="leading-relaxed mt-4">You may contact credit reporting bodies to suppress or review your report.</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">5</span>
              Marketing
            </h3>
            <p className="leading-relaxed">By providing your contact details, you authorise us and our brokers to contact you about relevant products and services via phone, email, SMS or digital means, unless you opt out.</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">6</span>
              Access & Correction
            </h3>
            <p className="leading-relaxed mb-4">You can request access to or correction of your personal or credit-related information. We aim to:</p>
            <ul className="list-disc ml-6 space-y-2 text-gray-700">
              <li>Acknowledge requests within 7 days</li>
              <li>Resolve access or correction within 30 days</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">7</span>
              Complaints
            </h3>
            <p className="leading-relaxed mb-4">If you are not satisfied with how we manage your information:</p>
            <ol className="list-decimal ml-6 space-y-2 text-gray-700">
              <li>Contact our <strong>Privacy Officer</strong> at the details above.</li>
              <li>If unresolved, escalate to:<br/>
                <strong>Office of the Australian Information Commissioner (OAIC)</strong><br/>
                <a href="https://www.oaic.gov.au/" className="text-blue-600 hover:text-blue-800 underline font-medium">www.oaic.gov.au</a> | <span className="font-medium">1300 363 992</span>
              </li>
            </ol>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3">8</span>
              View Our Full Policy & Credit Guide
            </h3>
            <p className="leading-relaxed">You can access our complete Privacy Policy, Customer Charter and Credit Guide online at:<br/>
              <a href="https://www.mortgagechoice.com.au/" className="text-blue-600 hover:text-blue-800 underline font-medium">mortgagechoice.com.au</a>
            </p>
          </div>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
            <p className="text-sm text-yellow-800 font-medium">
              ⏰ This consent is valid for 6 months from the date of acceptance and will require renewal.
            </p>
          </div>
        </div>
        
        {!hideCheckbox && (
          <div className="mt-8 pt-6 border-t border-gray-200">
            <label className="flex items-center space-x-3 cursor-pointer p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <input
                type="checkbox"
                checked={consented}
                onChange={(e) => onConsentChange(e.target.checked)}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              />
              <span className="text-sm font-medium text-gray-800">
                I have read and agree to the Mortgage Choice Privacy Policy
              </span>
            </label>
          </div>
        )}
      </div>
    );
  }
}

export default MortgageChoiceConsent; 